import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default function Master_add() {
  const { http, user } = AuthUser();
  const [formData, setFormData] = useState({
    item_name: "",
    cat_id: "",
    suplier: "",
    price: "",
    vendor: "",
    mrp: "",
  });
  const navigate = useNavigate();
  const initialState = {
    item_name: "",
    cat_id: "",
    suplier: "",
    price: "",
    vendor: "",
    mrp: "",
  };

  const [users, setUsers] = useState([]);
  const [departments, setdepartments] = useState([]);

  const handleChange = (e) => {
    setFormData({
      login_user: user.id,
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    http.get(`/category`).then((res) => {
      setdepartments(res.data.data);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await http.post("/master_add", formData);
      setFormData(initialState);
      setTimeout(() => {
        navigate("/jobcart/master");
      }, 1000); // 10 seconds
      toast.success("Master data added successfully !");
    } catch (error) {
      // Here we handle the error
      if (error.response && error.response.data) {
        // If there's a detailed error message from the server, use that
        toast.error(
          error.response.data.message || "Make sure all fields are filled!"
        );
      } else {
        // If there's no detailed error message, use a generic one
        toast.error("Make sure all fields are filled!");
      }
      console.error("Error adding task:", error);
    }
  };

  console.log(departments);

  return (
    <>
      <div className="container mt-5">
        <Toaster />
        <h3>Add Master Data</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group  mt-3">
            <select
              onChange={handleChange}
              name="cat_id"
              className="form-control mb-1"
              required
            >
              <option value="">Select Category</option>
              {departments.map((dept, index) => (
                <option key={index} value={dept.id}>
                  {dept.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group mt-3">
            <label>Item Name</label>
            <input
              type="text"
              name="item_name"
              className="form-control"
              onChange={handleChange}
              required
            ></input>
          </div>

          <div className="form-group mt-3">
            <label>Supplier</label>
            <input
              type="text"
              name="suplier"
              className="form-control"
              onChange={handleChange}
              required
            ></input>
          </div>

          <div className="form-group mt-3">
            <label>Price</label>
            <input
              type="text"
              name="price"
              className="form-control"
              onChange={handleChange}
              required
            ></input>
          </div>

          {/* <div className='form-group mt-3'>
                        <label>Vendor</label>
                        <input type='text'
                            name="vendor"
                            className='form-control'
                            onChange={handleChange} required
                        ></input>
                    </div> */}

          <div className="form-group mt-3">
            <label>MRP</label>
            <input
              type="text"
              name="mrp"
              className="form-control"
              onChange={handleChange}
              required
            ></input>
          </div>
          <button className="btn button btn-success mt-3" type="submit">
            Add Master
          </button>
        </form>
      </div>
    </>
  );
}
